/*@flow*/
import L from 'leaflet';

function parseString(bboxString) {
  return bboxString
    .split(',')
    .filter(Boolean)
    .map(parseFloat);
}

export default function mkLeafletBbox(bboxString: string): any {
  const bboxArr = parseString(bboxString);
  const [swLng, swLat, neLng, neLat] = bboxArr;
  return L.latLngBounds(L.latLng([swLat, swLng]), L.latLng([neLat, neLng]));
}
